/**
 * Task time formatter — KST 시간 + 오늘 외엔 M/D prefix.
 *
 * Why: cpTask·orphan task 가 multi-day quest 에서 cross-day 일 수 있음.
 * `formatTimeShort` 단독은 "HH:mm" 만 반환 → 어제·지난주 task 가 오늘과 구별 안 됨.
 * 본 util 은 task 가 *오늘* 이면 "HH:mm", 아니면 "M/D HH:mm" 으로 prefix.
 */

import { formatTimeShort } from './time';

const kstYmdFormat = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Seoul',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

function getKstYmd(d: Date): string {
  return kstYmdFormat.format(d); // "YYYY-MM-DD"
}

function getKstMonthDay(d: Date): string {
  const ymd = kstYmdFormat.format(d); // "2026-05-06"
  const [, month = '', day = ''] = ymd.split('-');
  return `${parseInt(month, 10)}/${parseInt(day, 10)}`; // "5/6"
}

/**
 * Format an ISO timestamp as "HH:mm" if same KST calendar day as `now`,
 * else "M/D HH:mm". Returns '-' for null.
 *
 * @param iso ISO 8601 string or null
 * @param now Reference "today" — defaults to current time. Pass a fixed Date for tests.
 */
export function formatTaskTime(iso: string | null, now: Date = new Date()): string {
  if (!iso) return '-';
  const date = new Date(iso);
  const time = formatTimeShort(iso);
  if (getKstYmd(date) === getKstYmd(now)) return time;
  return `${getKstMonthDay(date)} ${time}`;
}
